<script setup lang="ts">
import DeleteEntityDialog from '@/common/components/DeleteEntityDialog.vue';
import { Assert } from 'shared/assert';
import { useTemplateRef } from 'vue';
import { useDashboardStore } from '../stores/dashboardStore';
import { useDeleteDashboardApi } from '../api/deleteDashboardApi';
import { useRefreshDashboardStore } from '../stores/refreshDashboardStore';

const dialog = useTemplateRef('dialog');

defineExpose({
  show
});

const deleteApi = useDeleteDashboardApi();
const store = useDashboardStore();
const refreshStore = useRefreshDashboardStore();

function show(id: string) {
  dialog.value?.show(id);
}

async function onDelete(id: string) {
  const response = await deleteApi.execute({id});
  return response;
}

async function getById(id: string) {
  await refreshStore.initialize();
  const entity = store.getById(id);
  Assert.definied(entity);
  return {
    id: entity.id,
    name: entity.name
  };
}

</script>

<template>
  <DeleteEntityDialog
    ref="dialog"
    :delete="onDelete"
    :get-by-id="getById"
    :translate="(t) => t.dashboard.deleteDialog">
  </DeleteEntityDialog>
</template>
